import AppPageHeader from '../AppPageHeader';
import Scatter from '../scatterPlots/Scatter';
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/system';

/** @component
 * Chart tab on the mobile swipeable view.
 * @param data {Array<Object>} Data to display.
 * @param onClick {Function} event handler for when a user clicks a dot on the scatter plot.
 * @returns {Element}
 * @constructor
 */
const ChartTab = ({ data, onClick }) => {
    const theme = useTheme();
    return (
        <Stack spacing={2} sx={{ paddingTop: 2 }}>
            <AppPageHeader />
            <Scatter
                data={data}
                dataTestId={'ebabScatterPlot'}
                dataAnalyticsId='ebab-chart'
                onClick={onClick}
                size={theme.sizing.scatterPlot.frontierPoints.radius.initial}
                style={{
                    data: {
                        strokeWidth:
                            theme.sizing.scatterPlot.frontierPoints.stroke
                                .initial,
                        stroke: theme.palette.scatterPlot.frontierPoints.stroke
                            .initial,
                        fill: ({ datum }) => datum.dotColor
                    },
                    labels: {
                        fontFamily: theme.typography.fontFamily,
                        fontSize: 10 // can't be rem
                    }
                }}
            />
        </Stack>
    );
};

ChartTab.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    onClick: PropTypes.func
};

export default ChartTab;
